import React from 'react';
import { useLanguage, useProvider } from '~/Hooks';
import { Button, Typography } from '~/UIKit';
import { Route } from '~/Constants/Routes.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { Yogis } from '~/Components/Icons/brand/Yogis';

export interface IEventEmptyPlaceholderProps {
  noEventsThisWeek: boolean;
  onNextEventClick: () => void;
  classes: any;
}

export const EventEmptyPlaceholder = ({
  noEventsThisWeek,
  onNextEventClick,
  classes,
}: IEventEmptyPlaceholderProps) => {
  const { currentProvider } = useProvider();
  const { t } = useLanguage();

  return (
    <div className={classes.noEvents}>
      <Yogis />
      <Typography className={classes.noEventsLabel} variant="h4">
        {t('app.eventlist.noevents')}
      </Typography>
      <Typography
        dangerouslySetInnerHTML={{
          __html: t('eventlist.partner.placeHolder', {
            link: routeReplacer(Route.EVENT_CREATE, { domain: currentProvider?.domain || '' }),
          }),
        }}
      />
      <Button
        className={classes.nextEventButton}
        color="primary"
        onClick={onNextEventClick}
        variant="contained"
      >
        {noEventsThisWeek ? t('app.eventlist.nextweek') : t('app.eventlist.nextevent')}
      </Button>
    </div>
  );
};
